export const getFirebaseConfig = () => {
    let configString = process.env.VUE_APP_FIREBASE_CREDS;
    return JSON.parse(configString);
};

export const getHost = () => {
    return process.env.VUE_APP_CLIENT;
}